import * as T from "../Controls.style";
import { get } from "lodash";
import { InputLogin } from "@/components/atoms/Inputs/InputLogin";
import { ChangeEvent } from "react";
import { Control, Controller } from "react-hook-form";

interface LoginControlProps {
  max?: string;
  name: string;
  type: "text" | "password";
  label?: string;
  control: Control<any>;
  tabIndex?: number;
  required?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  defaultValue?: string;
}

export const LoginControl = ({
  max,
  type,
  name,
  label,
  control,
  required,
  tabIndex,
  placeholder,
  defaultValue,
}: LoginControlProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, formState }) => (
        <T.Controls>
          <InputLogin
            label={label}
            required={required ? required : false}
            type={type}
            placeholder={placeholder}
            max={max}
            tabIndex={tabIndex}
            field={field}
            {...field}
          />
          {get(formState.errors, name)?.message && (
            <span>
              <>{get(formState.errors, name)?.message}</>
            </span>
          )}
        </T.Controls>
      )}
    />
  );
};
